import { Injectable, Injector } from '@angular/core';
import { BitfODataBatchService } from '@bitf/core/services/api/bitf-odata-batch.service';

@Injectable({ providedIn: 'root' })
export class AbocaBatchService extends BitfODataBatchService {
  constructor(injector: Injector) {
    super(injector);
  }
}
